import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=77aa92bc&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa92bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77aa92bc')) {
      api.createRecord('77aa92bc', component.options)
    } else {
      api.reload('77aa92bc', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=77aa92bc&scoped=true&", function () {
      api.rerender('77aa92bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/Templates.vue"
export default component.exports